import React from 'react';
import '../styles/AnnouncementSection.css';
import announcement_img from "../assets/announcement.jpg";

const AnnouncementSection = () => {
  return (
    <section className="announcement-section">
      <h2 className="announcement-title">-- ANNOUNCEMENTS --</h2>
      <div className="announcement-image">
        <img src={announcement_img} alt="Hackathon 2025 Announcement" />
      </div>
      <div className="announcement-content">
      </div>
    </section>
  );
};

export default AnnouncementSection;
